import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserLogoutComponent } from './auth/user/logout/logout.component';
import { PublisherUserLogoutComponent } from './auth/publisher-user/logout/logout.component';
import { PublisherUserChangePasswordComponent } from './auth/publisher-user/change-password/change-password.component';
import { PublisherForbiddenErrorComponent } from './auth/publisher-user/forbidden-error/forbidden-error.component';
import { Paths } from './models/enums';

const routes: Routes = [
    {
        path: 'owner/login',
        loadChildren: './auth/user/auth.module#UserAuthModule'
    },
    { path: 'owner/logout', component: UserLogoutComponent },
    {
        path: 'publisher/login',
        loadChildren: './auth/publisher-user/auth.module#PublisherUserAuthModule'
    },
    { path: 'publisher/logout', component: PublisherUserLogoutComponent },
    {
        path: 'publisher/change-password',
        component: PublisherUserChangePasswordComponent
    },
    {
        path: 'publisher/forbidden-error',
        component: PublisherForbiddenErrorComponent
    },
    { path: '', redirectTo: Paths.Publisher, pathMatch: 'full' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/app-routing.module.ts